<template>
  <div class="geo-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}}
    </div>
    <doughnut-chart
      v-if="isLoaded"
      :chart-data="dataDoughnutCollection"
      :options="doughnutOptions"
      class="geo-content__chart"
      :height="350"
    ></doughnut-chart>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.audit.geo.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { DoughnutChart } from "../../../../../../../../components/charts";

  // mixins
  import geo from "../../../../../../../../mixins/chart/geo";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import geoConfig from "../../../../../../../../config/geoConfig";

  export default {
    name: "GeoBody",
    props: {
      chartData: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      activeCity: {
        type: String
      },
    },
    data() {
      return {
        geoConfig: this.$t('feed.audit.geo.body.config'),
        chartId: "Geo",
        showLabel: true,
        cityKey: 'users_city',
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      isLoaded() {
        return !!Object.keys(this.chartData).length;
      },
    },
    mixins: [
      geo,
      saveImage
    ],
    components: {
      DoughnutChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .geo-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
